import React, { Component } from "reactn";
import styled from "styled-components";
import {
    DialogTitle,
    DialogActions,
    Button,
    TextField
} from "@material-ui/core";

import { BeautifulDialog, DialogContent, ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { FlexBox } from "js/react/components/LayoutGrid";
import AddTagsDialog from "js/react/views/UserOptions/dialogs/AddTagsDialog";
import { Field } from "js/react/components/UiComponents";
import TagsList from "js/react/components/TagsList";

const SubText = styled.div`
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.5px;
    padding-top: 10px;
`;

export default class CreateTeamTemplateDialog extends Component {
    constructor(props) {
        super(props);
        let {
            name = "",
            description = "",
            tags = [],
        } = props;

        this.state = {
            name,
            description,
            tags,
        };
    }

    handleRemoveTag = tag => {
        const { tags } = this.state;
        let index = tags.indexOf(tag);
        if (index > -1) {
            tags.splice(index, 1);
            this.setState({
                tags,
            });
        }
    }

    handleAddTag = () => {
        let {
            existingTags,
        } = this.props;
        let {
            tags,
        } = this.state;

        ShowDialog(AddTagsDialog, {
            activeTags: tags,
            existingTags,
            acceptCallback: newTags => {
                this.setState(({ tags }) => ({
                    tags: [...new Set([...tags, ...newTags])]
                }));
            },
        });
    }

    handleAccept = isPublished => {
        let {
            callback,
            closeDialog,
        } = this.props;

        !!callback && callback({
            ...this.state,
            isPublished,
        });
        closeDialog();
    }

    render() {
        let {
            closeDialog,
            title = "[Title Missing]",
            subTitle = "[subTitle Missing]",
        } = this.props;

        let {
            name,
            description,
            tags,
        } = this.state;

        return (
            <BeautifulDialog closeDialog={closeDialog}>
                <DialogTitle>
                    <div>{title}</div>
                    <SubText>{subTitle}</SubText>
                </DialogTitle>

                <DialogContent
                    style={{
                        paddingLeft: 80,
                        paddingRight: 80,
                        overflowY: "hidden",
                    }}
                >
                    <Field title="Template Name">
                        <TextField
                            autoFocus
                            id="name"
                            value={name}
                            placeholder="Template name..."
                            fullWidth
                            onChange={event => this.setState({ name: event.target.value })}
                        />
                    </Field>
                    <Field title="Add a description or instructions (optional)">
                        <TextField
                            multiline
                            id="description"
                            value={description}
                            placeholder="Type a description here..."
                            fullWidth
                            onChange={event => this.setState({ description: event.target.value })}
                        />
                    </Field>
                    <Field title="Add tags to facilitate search (optional)">
                        <TagsList
                            tags={tags}
                            onRemove={this.handleRemoveTag}
                            onClick={this.handleAddTag}
                        />
                    </Field>
                </DialogContent>

                <DialogActions style={{ justifyContent: "space-between" }}>
                    <Button onClick={closeDialog} color="secondary">Cancel</Button>
                    <FlexBox>
                        <Button onClick={() => this.handleAccept(false)} color="secondary">Save as Draft</Button>
                        <Button onClick={() => this.handleAccept(true)} color="primary">Publish Now</Button>
                    </FlexBox>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
